<template>
  <button v-if="store.showButton"
          class="lbs-uscope-toolbar-button adjust-button"
          @click="onClick"
          @mouseenter="showPresetList"
          @mouseleave="hidePresetList"
          :title="getButtonTitle"
  >
    <div class="button-overlay"/>
    <icon name="adjust"/>
    <div class="arrow-thing"
         v-if="presetsExist"
    >
      <ul class="dropdown-menu show"
          @click.stop
          v-show="showPresets"
      >
        <b-dropdown-item v-for="preset in store.presets"
                         :key="preset.name"
                         :class="{ 'active': preset === store.selectedPreset }"
                         @click.stop.prevent="applyPreset(preset)"
        >
          <span class="name-container">{{ preset.name }}</span>
          <span class="icon-container">
            <icon name="check"/>
          </span>
        </b-dropdown-item>
      </ul>
    </div>
  </button>
</template>

<script>
  import Icon from 'vue-awesome/components/Icon';
  import 'vue-awesome/icons/adjust';
  import 'vue-awesome/icons/check';
  import ToolbarButton from '../../components/vue/toolbar-button';

  const HOVER_DELAY = 250;

  export default {
    name: 'ImageAdjustButton',
    components: {
      ToolbarButton,
      Icon
    },
    i18nOptions: {
      keyPrefix: 'uScope.extensions.image-adjust'
    },
    props: {
      store: {
        required: true,
        type: Object
      },
      onClick: {
        type: Function,
        required: true
      }
    },
    data () {
      return {
        showPresets: false,
        showPresetsTimer: null
      };
    },
    computed: {
      presetsExist () {
        return this.store.presets.length > 0;
      },
      getButtonTitle () {
        return this.presetsExist ? '' : this.$t('toolbar-button-hover-text');
      }
    },
    methods: {
      showPresetList () {
        clearTimeout(this.showPresetsTimer);
        this.showPresetsTimer = setTimeout(() => {
          this.showPresets = true;
        }, HOVER_DELAY);
      },
      hidePresetList () {
        clearTimeout(this.showPresetsTimer);
        this.showPresetsTimer = setInterval(() => {
          this.showPresets = false;
        }, HOVER_DELAY);
      },
      applyPreset (preset) {
        this.store.applyPreset(preset);
        // Does it make sense to hide the list? Seems kinda annoying actually.
      }
    }
  };
</script>

<style scoped lang="scss">
@import "~lbs-pi-web-styles/lib/variables";
@import "image-adjust";
$uScope-puke-blue: #3E6587; // todo- make shared

.adjust-button {
  position: relative;
  color: $uScope-puke-blue;

  > * {
    position: absolute;
    top: 3px;
    left: 3px;
  }

  .button-overlay {
    position: absolute;
    inset: 0;
    z-index: 2;
  }
}

.arrow-thing {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 9px 9px;
  border-color: transparent transparent $uScope-puke-blue transparent;
  margin-left: 11px;
  margin-top: 11px;
}

.name-container {
  padding-left: 10px;
}

.dropdown-menu {
  .icon-container {
    display: none;
  }

  .active {
    .name-container {
      text-decoration: underline;
    }
    .icon-container {
      display: inline-block;
    }
  }
}
</style>
